import { AgResourceLanguage } from '../types';
import { sharePacks as EnUsSharePacks } from '../en-us/sharePacks';

export const sharePacks: AgResourceLanguage['sharePacks'] = {
  ...EnUsSharePacks,
  shippingFields: {
    ...EnUsSharePacks.shippingFields,
    title: 'Waar sturen we dit gratis cadeau naartoe?',
    subtitle:
      'Je vriend ontvangt zijn AG1 Reisverpakkingen binnen 3 - 5 werkdagen. Je kunt de levering volgen in je bestelgeschiedenis.',
    email: 'E-mail van vriend',
    giftMessage: 'Cadeaubericht (maximaal 500 tekens)',
    country: 'Land/regio',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    addressLine1: 'Adres',
    addressLine2: 'Appartement, Suite, Etc (optioneel)',
    city: 'Stad',
    state: 'Provincie',
    zipCode: 'Postcode',
    phone: 'Telefoon',
    submitButtonText: 'Opslaan',
    cancelButtonText: 'Annuleren',
    label: 'Verstuur als cadeau',
    caption: `
    <p>Door deze bestelling te plaatsen, ga je akkoord met de 
      <a href="https://drinkag1.com/terms-and-conditions" target="_blank" rel="noopener">Algemene Voorwaarden</a> 
      en&nbsp;<a href="https://drinkag1.com/privacy" target="_blank" rel="noopener">Privacybeleid</a>.
    </p>
  `
  },
  commonError: 'Er ging iets mis. Probeer het later opnieuw.',
  title: 'Deel GRATIS AG1 Reisverpakkingen met je vrienden:',
  subtitle:
    'Geef ze een voorproefje van hoe goed het voelt om je gezondheid in eigen handen te nemen, met een pakket van 5 — op ons.*',
  disclosure:
    '*Beperkt tot actieve abonnees. Het aanbod voor gratis AG1 Reisverpakkingen is geldig voor 30 dagen na melding. Gratis AG1 Reisverpakkingen zijn niet overdraagbaar, moeten worden ingewisseld via het ledenportaal en kunnen alleen naar adressen in de VS worden verzonden. Limiet van drie AG1 Reisverpakkingen per gekwalificeerde klant.',
  status: {
    shared: 'Je hebt al je pakketten gedeeld',
    expired:
      'Het pilotprogramma voor het delen van Gratis Pakketten is beëindigd, kom later terug voor meer!',
    limited: 'Tijdelijk Programma',
    expiring: 'Het aanbod voor Gratis Reisverpakkingen verloopt op {{date}}.'
  },
  button: {
    ...EnUsSharePacks.button,
    share: 'Deel 5 Reisverpakkingen',
    expired: 'Verlopen',
    viewOrder: 'Bekijk Bestelling',
    shared: 'Gedeeld'
  },
  modal: {
    ...EnUsSharePacks.modal,
    head: 'Deel Gratis Reisverpakkingen',
    title: 'Waar sturen we dit gratis cadeau naartoe?',
    subtitle:
      'Je vriend ontvangt zijn AG1 Reisverpakkingen binnen 3 - 5 werkdagen. Je kunt de levering volgen in je bestelgeschiedenis.'
  },
  checkout: {
    ...EnUsSharePacks.checkout,
    success: 'Je bestelling is succesvol aangemaakt.'
  },
  subscriptionFreeGiftName: 'Deel Gratis Pakketten',
  buttonTrack: 'Bestelling Volgen',
  freeGiftPrice: 'Gratis',
  subscriptionNameLabel: 'Besteltype'
};
